import React from "react";

const ProductImages = ({
    images,
    isMobile,
    selectedImage,
    currentImageIndex,
    onImageClick,
    onSwapImage
}) => {
    if (!images || images.length === 0) return null;

    return (
        <>
            {/* Desktop Image Gallery */}
            {!isMobile && (
                <div className="itemD-images">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Product ${index + 1}`}
                            onClick={() => onImageClick(index)}
                            style={{ cursor: "pointer" }}
                        />
                    ))}
                </div>
            )}

            {/* Mobile Image Display */}
            {isMobile && (
                <>
                    <div className="mobile-main-image">
                        <img
                            src={selectedImage}
                            alt="Selected"
                            onClick={() => onImageClick(currentImageIndex)}
                            style={{ cursor: "pointer" }}
                        />
                    </div>

                    {images.length > 1 && (
                        <div className="mobile-thumbnails">
                            {images.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt={`thumbnail-${index}`}
                                    onClick={() => onSwapImage(index)}
                                    className={`thumbnail ${index === currentImageIndex ? "active" : ""}`}
                                />
                            ))}
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default ProductImages;